import axios from "axios";
import { LoginContext } from "contexts/LoginContext";
import CryptoJS from 'crypto-js';
import { useContext } from "react";
import { useMutation, useQueryClient } from "react-query";

export default function useCreateApplicationUser() {
  const { config, user, providerId } = useContext(LoginContext);

  const queryClient = useQueryClient();
  const key = 'pj23vs7nycq18uew';
  let secretKey = CryptoJS.enc.Utf8.parse(key);

  const encryptPassword = (password, secretKey) => {

    let encryptedBytes = CryptoJS.AES.encrypt(password, secretKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    let encryptedString = encryptedBytes.toString();

    console.log(encryptedString, 'encryptedone');
    return encryptedString;
    // return CryptoJS.AES.encrypt(password, secretKey).toString();
  }
  const decryptPassword = (encryptedPassword, secretKey) => {

    let decryptedBytes = CryptoJS.AES.decrypt(encryptedPassword, secretKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    let decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);

    // console.log(decryptedText, 'decryptedone');
    return decryptedText;
    // const bytes = CryptoJS.AES.decrypt(encryptedPassword, secretKey);
    // return bytes.toString(CryptoJS.enc.Utf8);
  }
  return useMutation(
    async (userDataObj) => {

      console.log(userDataObj, 'createobj')
      let userPayload = userDataObj?.users;

      if (!userPayload.address) userPayload.address = " ";
      if (!userPayload.middleName) userPayload.middleName = " ";
      if (!userPayload.userName) userPayload.userName = userPayload.email;


      if (!userPayload.passCode) userPayload.passCode = "test";


      userPayload.createdBy = (userPayload.createdBy == "" || userPayload.createdBy == null) ? (user ?? "system") : userPayload.createdBy;
      userPayload.updatedBy = (userPayload.updatedBy == "" || userPayload.updatedBy == null) ? (user ?? "system") : userPayload.updatedBy;
      userPayload.providerId = userPayload?.providerId || providerId;
      userPayload.isActive = true;
      userPayload.passCode = encryptPassword(userPayload.passCode, secretKey);
      console.log("userPayload " + userPayload)
      await axios.post(`${config.api}/api/User/${userDataObj.prevSelectedId}`, userPayload);
    },
    {
      onSuccess: (x) => {
        console.log(x, 'usersResp')
        queryClient.invalidateQueries("users");
      },
    }
  );
}
